module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-02-en.f41c2121bd23f1460439a5fedc511512.png";